import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'react-app-polyfill/ie11';

export const fetchPopupData = async (url) => {
  const response = await fetch(url, {
    method: 'GET',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
    }
  });
  const result = await response.json();
  if (result.status === 200) {
    return result.data;
  } else {
    throw new Error("表示項目の取得中にエラーが発生しました。");
  }
};